import { CreateOrUpdateBaseService } from "../../../../common/services/createOrUpdateBase.service";
import { services } from "../../../../constants/services";

export interface procedureData {
  procedureId: number | null;
  procedureName: string;
  description: string;
  requirements: string;
  status: any;
}


export class CreateOrUpdatedProcedureService extends CreateOrUpdateBaseService<procedureData, any> {
  // url = `${services.userCampus}/createOrUpdateUserCampus`;
  url = `${services.procedures}`;

};

